import { Result, failure, success } from '../shared'
import { LookupsProvider } from './lookups.provider'
import { LookupsServiceErrorCode, LookupsServerData, LookupType } from './lookups.types'

export class LookupsService {
  constructor(private provider: LookupsProvider) {}

  public async get(type: LookupType): Promise<Result<LookupsServerData>> {
    try {
      const { data } = await this.provider.get(type)
      return success(data)
    } catch (error) {
      return failure(LookupsServiceErrorCode.GENERAL)
    }
  }

  public async getCitiesByCountryID(type: LookupType, CountryID: string): Promise<Result<LookupsServerData[]>> {
    try {
      const { data } = await this.provider.getWithParams(type, {
        CountryID,
      })
      return success(data)
    } catch (error) {
      return failure(LookupsServiceErrorCode.GENERAL)
    }
  }
}
